import React from 'react';

import formatPrice from '../../../../../helpers/formatPrice';
import { Discount } from '../../../../../types/api/discounts/Discount';

import Typography from '../../../../../components/_ui/_blocks/Typography/Typography';
import Tag from '../../../../../components/_ui/_blocks/Tag/Tag';

export const DiscountRowLoading = () => (
    <li>
        <div className="flex items-center gap-050 flex-grow">
            <div className="skeleton-animation w-full max-w-[10.25rem] h-[1.375rem]" />
            <div className="skeleton-animation w-[3.5rem] h-[1.375rem]" />
        </div>
        <div className="skeleton-animation w-[2.75rem] h-[1.375rem]" />
    </li>
);

interface Props {
    discountAmount: number;
    discount: Discount;
}

const DiscountRow = ({ discountAmount, discount }: Props) => (
    <li>
        <Typography as="div" size="090" className="flex items-center gap-050">
            {discount.label}
            <Tag size="medium" color="discountCode">{discount.code}</Tag>
        </Typography>
        <div>-{formatPrice(discountAmount)}</div>
    </li>
);

export default DiscountRow;
